import axiosClient from './axiosClient'
const countryApi = {
  getAll: (params) => {
    const url = '/country/getAll'
    return axiosClient.get(url, { params })
  },
}
export default countryApi
